/* eslint-disable */
import axios from "assets/js/request";
import SiteConstants from 'assets/const/SiteConstants.json';
import UrlConstants from "assets/const/UrlConstants";
import common from "assets/js/common";

var entetsu = {
    cookieUrl: '',
    cookieSesId: '',
    cookieSesStatusCd: '',
    cookieAutoLoginStatusCd: '',
    cookieDomain: '',

    /**
     * 遠鉄 えんてつポイントをCookie取得
     */
    getEntetsuCookie: async function(){
        let _this = this;
        await axios.get(_this.cookieUrl + UrlConstants.GET_ENTETSU_COOKIE, {withCredentials: true}).then(function(response) {
            _this.cookieSesId = response.data.sid;
            _this.cookieSesStatusCd = response.data.sessionStatusCd;
            _this.cookieAutoLoginStatusCd = response.data.etCardsAuth;
            _this.cookieDomain = response.data.domain;
            //console.log("cookie:");
            //console.log(response.data);
        }).catch(function(error) {
            throw new Error(error.message);
        });
    },

    /**
     * 遠鉄 えんてつポイントをCookie取得
     */
    setEntetsuCookie: async function(param){
        let _this = this;
        await axios.post(_this.cookieUrl + UrlConstants.SET_ENTETSU_COOKIE, param, {withCredentials: true}).then(function(response) {
            //console.log(response.data);
        }).catch(function(error) {
            throw new Error(error.message);
        });
    },
   
    /**
    * cookieに情報をセット
    * @param {String} name, cookie name
    * @param {String} value, cookie value
    * @param {int} minutes, cookie expires
    * @param {String} path, path expires
    **/
    setCookie: async function(name, value, minutes = 20, path = "/") {
        let _this = this;
        const param = {
            name: name,
            value: value,
            path: path,
            maxAge: minutes,
            optionKbn: 0,
            maxAgeUnit: 2,
            domain: _this.cookieDomain
        };

        await _this.setEntetsuCookie(param);
    },

    /**
    * cookieに情報をセット
    * @param {String} name, cookie name
    * @param {String} value, cookie value
    * @param {String} expires, cookie expires
    * @param {String} path, path expires
    **/
    setCookieByExpires: async function(name, value, expires, path = "/") {
        let _this = this;
        const param = {
            name: name,
            value: value,
            path: path,
            optionKbn: 0,
            expires: expires,
            domain: _this.cookieDomain
        };
        await _this.setEntetsuCookie(param);
    },

     /**
    * cookieに情報を削除する
    * @param {String} name, cookie name
    **/
    deleteCookie: async function(name, path = "/") {
        let _this = this;
        const param = {
            name: name,
            path: path,
            maxAge: 0,
            optionKbn: 2,
            domain: _this.cookieDomain
        };
        await _this.setEntetsuCookie(param);
    },

    /**
    * E-ASPRO上はセッション, cookieのクリア。
    * 
    **/
    clear: async function(){
        await this.deleteCookie("session_statuscd");
        //console.log("delete session_statuscd !!!");
        await this.deleteCookie("ET_CARDS_AUTH");
        //console.log("delete ET_CARDS_AUTH !!!");

        sessionStorage.removeItem('entetsu_logout_flg');
        sessionStorage.removeItem('kainInfo');
        sessionStorage.removeItem('kaiin');
    },

    /**
    * E-ASPRO上はセッション切れの状態とし、元画面に戻す。
    * 
    **/
    goBack: function(){
        sessionStorage.setItem('entetsu_api_err', '1');
        if (window.history.length > 1) {
            router.go(-1);
        } else {
            router.push('/');
        }
        //window.history.back();
    },

    /**
    * E-ASPRO上はセッション切れの状態とし、元画面に戻す。
    * 
    **/
    logout: async function(router, pageNo){
        let _this = this;
        try {
            const response =  await axios.get(UrlConstants.ECSITE + UrlConstants.PT060 + UrlConstants.LOGOUT);
            if(response.data.status == 'OK'){
                var site = router.history.current.fullPath.split("/")[1];
                common.removeLocalStorageEcSite(site);

                sessionStorage.removeItem('kainInfo');
                sessionStorage.removeItem('kaiin');
                if (pageNo > 0){
                    _this.gotoTopPage(router, pageNo);
                }
                console.log('遠鉄個人会員 Loginout !!!');
            }
            return true;
        } catch (error) {
            console.log('ログアウトエラー:');
            console.log(error);
            throw new Error(e.message);
            return false;
        }
    },

    /**
    * E-ASPRO上はTop画面に戻す。
    * 
    **/
    gotoTopPage: function(router, pageNo){
        //console.log("pageNo:" + pageNo);
        router.push({ name: SiteConstants.PG010MAIN, query: {pageNo: pageNo}});
    },

    /** 
    * えんてつポイント セッションID取得
    **/
    getSessionId : async function () {
        const response = await axios.post(UrlConstants.ECSITE + UrlConstants.PG010MAIN + UrlConstants.GET_ENTETSU_SESSION_ID)
        .catch(function(error) {
            throw new Error(error.message);
        });
        //console.log(response.data);
        return response.data;
    },

    /** 
    * えんてつポイント セッション状態確認 
    * @param {String} sesId, cookieのJSESSIONID セッションID
    * @param {String} sesStatusCd, cookieのsession_statuscd セッションID状態コード
    **/
    getSessionConf : async function (sesId, sesStatusCd) {
        let _this = this;
        var request = {
            "kbnCd": "",
            "sesId": sesId,
            "sesStatusCd": sesStatusCd,
            "sysCd": "",
            "sysTimestamp": ""
        };
        const response = await axios.post(UrlConstants.ECSITE + UrlConstants.PG010MAIN + UrlConstants.DO_ENTETSU_SESSIONCONF, request)
        .catch(function(error) {
            throw new Error(error.message);
        });
        //console.log("getSessionConf:");
        //console.log(response.data);
        
        return response.data;
    },

    /** 
    * えんてつポイント セッション状態更新
    * @param {String} sesId, cookieのJSESSIONID セッションID
    * @param {String} sesStatusCd, cookieのsession_statuscd セッションID状態コード
    **/
    getSessionUpd : async function (sesId, sesStatusCd) {
        let _this = this;

        var request = {
            "kbnCd": "",
            "sesId": sesId,
            "sesStatusCd": sesStatusCd,
            "sysCd": "",
            "sysTimestamp": ""
        };
        const response = await axios.post(UrlConstants.ECSITE + UrlConstants.PG010MAIN + UrlConstants.DO_ENTETSU_SESSIONUPD, request)
        .catch(function(error) {
            throw new Error(error.message);
        });
        //console.log("getSessionUpd:");
        //console.log(response.data);
        return response.data;
    },

    /** 
    * えんてつポイント オートログイン状態確認
    * @param {String} sesId, cookieのJSESSIONID セッションID
    * @param {String} autoLoginStatusCd, cookieのET_CARDS_AUTH オートログイン用コード
    **/
    getAutoLoginConf : async function (sesId, autoLoginStatusCd) {
        let _this = this;

        var request = {
            "kbnCd": "",
            "sesId": sesId,
            "autoLoginStatusCd": autoLoginStatusCd,
            "sysCd": "",
            "sysTimestamp": ""
        };
        const response = await axios.post(UrlConstants.ECSITE + UrlConstants.PG010MAIN + UrlConstants.DO_ENTETSU_AUTOLOGINCONF, request)
        .catch(function(error) {
            throw new Error(error.message);
        });
        //console.log("getAutoLoginConf:");
        //console.log(response.data);
        return response.data;
    },

    /** 
    * えんてつポイント オートログイン状態確認
    * @param {String} sesId, cookieのJSESSIONID セッションID
    * @param {String} kaiNo, お客様番号
    **/
    getNetmemberinfo : async function (sesId, kaiNo) {
        let _this = this;
        var request = {
            "kaishaCd": "",
            "tenCd": "",
            "kbnCd": "",
            "sesId": sesId,
            "kaiNo": kaiNo,
            "sysCd": "",
            "sysTimestamp": ""
        };
        const response = await axios.post(UrlConstants.ECSITE + UrlConstants.PG010MAIN + UrlConstants.DO_ENTETSU_NETMEMBERINFO, request)
        .catch(function(error) {
            throw new Error(error.message);
        });
        //console.log("getNetmemberinfo:");
        //console.log(response.data);
        return response.data;
    },

    /** 
    * えんてつポイント ➀セッション状態チェック
    * Cookieからセッション情報を取得し、えんてつポイントWEBシステムにセッションが有効かチェックを行う。
    **/
    sessionStatusCheck: async function(){
        let _this = this;
        let sesId =  this.cookieSesId;
        let sesStatusCd = _this.cookieSesStatusCd;

        let result = {
            sesId: sesId,//セッションID
            sesStatusCd: sesStatusCd, //セッションID状態コード
            kekka: '', //処理結果
            sesStatus: '', //セッション状態結果
            kaiNo: '', //お客様番号
        };

        //えんてつポイント セッション状態確認
        if (sesStatusCd){
            let checkResult = await _this.getSessionConf(sesId, sesStatusCd);
            if (checkResult){
                if (checkResult.status == "OK"){
                    result.kekka = checkResult.response.kekka;
                    result.sesStatus = checkResult.response.sesStatus;
                    result.kaiNo = checkResult.response.kaiNo;
                }
            }
        }

        return result;
    },

    /** 
    * ②オートログイン状態チェック
    * Cookieからオートログイン情報を取得し、えんてつポイントWEBシステムにオートログイン状態が有効かチェックを行う。
    **/
    autoLoginStatusCheck: async function(){
        let _this = this;
        let sesId =  _this.cookieSesId;
        let autoLoginStatusCd = _this.cookieAutoLoginStatusCd;

        let result = {
            sesId: sesId,//セッションID
            autoLoginStatusCd: autoLoginStatusCd, //オートログイン用コード cookie
            resAutoLoginStatusCd: '', //返却オートログイン用コード 有効期限外はログイン不可の返却。有効期限内は新たなコードを生成し返却。
            expires: '', //Cookie「ET_CARDS_AUTH」の有効期限に設定
            kekka: '', //処理結果
            autoLoginStatus: '', //オートログイン状態
            kaiNo: '', //お客様番号
            sesStatusCd:  '' //セッションID状態コード
        };

        //えんてつポイント セッション状態確認
        if (autoLoginStatusCd){
            let checkResult = await _this.getAutoLoginConf(sesId, autoLoginStatusCd);
            if (checkResult){
                if (checkResult.status == "OK"){
                    result.resAutoLoginStatusCd = checkResult.response.autoLoginStatusCd;
                    result.expires = checkResult.response.expires;
                    result.kekka = checkResult.response.kekka;
                    result.autoLoginStatus = checkResult.response.autoLoginStatus;
                    result.kaiNo = checkResult.response.kaiNo;
                    result.sesStatusCd = checkResult.response.sesStatusCd;

                    //Cookie更新
                    if (result.kekka == "10" && result.autoLoginStatus == '1'){
                        //Cookie.オートログインコード（ET_CARDS_AUTH）　＝　APIレスポンス.オートログインコード（AUTOLOGINSTATUSCD）※有効期限はAPIレスポンス.オートログイン有効期限（EXPIRES）
                        //if (_this.cookieAutoLoginStatusCd != ""){
                        //    await _this.deleteCookie('ET_CARDS_AUTH');
                        //}
                        await _this.setCookieByExpires("ET_CARDS_AUTH", result.resAutoLoginStatusCd, result.expires);

                        //Cookie.セッション状態コード（session_statuscd）　＝　APIレスポンス.セッション状態コード（SESSTATUSCD）　※有効期限は固定20分後
                        //if (_this.cookieSesStatusCd != ""){
                        //    await _this.deleteCookie('session_statuscd');
                        //}
                        //if (_this.cookieSesStatusCd == ""){
                            await _this.setCookie("session_statuscd", result.sesStatusCd, -1);
                        //}
                        
                    }
                }
            }
        }

        return result;
    },

    /** 
    * えんてつポイント ➂セッション状態更新API
    * セッションの有効期限を延ばすためにAPIを実行する。APIから返された内容でCookieを更新する。
    * @param {String} sesStatusCd, cookie session_statuscd
    **/
    sessionUpdCheck: async function(sesStatusCd){
        let _this = this;
        let sesId =  _this.cookieSesId;

        let result = {
            sesId: sesId,//セッションID
            sesStatusCd: sesStatusCd, //セッションID状態コード
            kekka: '', //処理結果
            sesStatus: '', //セッション状態結果
            kaiNo: '', //お客様番号
        };

        //えんてつポイント セッション状態確認
        if (sesStatusCd){
            let checkResult = await _this.getSessionUpd(sesId, sesStatusCd);
            if (checkResult){
                if (checkResult.status == "OK"){
                    result.kekka = checkResult.response.kekka;
                    result.sesStatus = checkResult.response.sesStatus;
                    result.kaiNo = checkResult.response.kaiNo;
                    result.sesStatusCd = checkResult.response.sesStatusCd;

                    //Cookie更新
                    //if (result.kekka == '10'){
                    //    await _this.setCookie("session_statuscd", checkResult.response.sesStatusCd);
                    //}
                }
            }
        }

        return result;
    },

    /** 
    * えんてつポイント ➃ポイント情報取得
    * えんてつポイントWEBシステムより最新のポイント情報を取得する。
    * @param {String} kaiNo, お客様番号
    **/
    netmemberinfoCheck: async function(kaiNo){
        let _this = this;
        let sesId =  _this.cookieSesId;

        let result = {
            kaishaCd: '',
            tenCd: '',
            kbnCd: '',
            sesId: sesId,
            kaiNo: kaiNo,
            kekka: '',
            nname1: '',
            nname2: '',
            kname1: '',
            kname2: '',
            sex: '',
            zip1: '',
            zip2: '',
            ken: '',
            adr1: '',
            adr2: '',
            adr3: '',
            yukoYyMmDd: '',
            kanouPointF: '',
            kanouPoint: '',
            kikanYyMmDd: '',
            kikanPointF: '',
            kikanPoint: '',
            kikanPointZenF: '',
            kikanPointZen: '',
            cardJyotai: '',
            jtel1: '',
            jtel2: '',
            jtel3: '',
            ktel1: '',
            ktel2: '',
            ktel3: '',
            email: '',
            birth: '',
            yukoDate: '',
            cardSyuFlg: '',
            kozaNasiF: '',
            dmFlg: '',
            depaMailFlg: '',
            baseKey: '',
            sysCd: '',
            sysTimestamp: ''
        };

        //えんてつポイント セッション状態確認
        if (kaiNo){
            let checkResult = await _this.getNetmemberinfo(sesId, kaiNo);
            if (checkResult){
                if (checkResult.status == "OK"){
                    result.kaishaCd = checkResult.response.kaishaCd;
                    result.tenCd = checkResult.response.tenCd;
                    result.kbnCd = checkResult.response.kbnCd;
                    result.sesId = checkResult.response.sesId;
                    result.kaiNo = checkResult.response.kaiNo;
                    result.kekka = checkResult.response.kekka;
                    result.nname1 = checkResult.response.nname1;
                    result.nname2 = checkResult.response.nname2;
                    result.kname1 = checkResult.response.kname1;
                    result.kname2 = checkResult.response.kname2;
                    result.sex = checkResult.response.sex;
                    result.zip1 = checkResult.response.zip1;
                    result.zip2 = checkResult.response.zip2;
                    result.ken = checkResult.response.ken;
                    result.adr1 = checkResult.response.adr1;
                    result.adr2 = checkResult.response.adr2;
                    result.adr3 = checkResult.response.adr3;
                    result.yukoYyMmDd = checkResult.response.yukoYyMmDd;
                    result.kanouPointF = checkResult.response.kanouPointF;
                    result.kanouPoint = checkResult.response.kanouPoint;
                    result.kikanYyMmDd = checkResult.response.kikanYyMmDd;
                    result.kikanPointF = checkResult.response.kikanPointF;
                    result.kikanPoint = checkResult.response.kikanPoint;
                    result.kikanPointZenF = checkResult.response.kikanPointZenF;
                    result.kikanPointZen = checkResult.response.kikanPointZen;
                    result.cardJyotai = checkResult.response.cardJyotai;
                    result.jtel1 = checkResult.response.jtel1;
                    result.jtel2 = checkResult.response.jtel2;
                    result.jtel3 = checkResult.response.jtel3;
                    result.ktel1 = checkResult.response.ktel1;
                    result.ktel2 = checkResult.response.ktel2;
                    result.ktel3 = checkResult.response.ktel3;
                    result.email = checkResult.response.email;
                    result.birth = checkResult.response.birth;
                    result.yukoDate = checkResult.response.yukoDate;
                    result.cardSyuFlg = checkResult.response.cardSyuFlg;
                    result.kozaNasiF = checkResult.response.kozaNasiF;
                    result.dmFlg = checkResult.response.dmFlg;
                    result.depaMailFlg = checkResult.response.depaMailFlg;
                    result.baseKey = checkResult.response.baseKey;
                    result.sysCd = checkResult.response.sysCd;
                    result.sysTimestamp = checkResult.response.sysTimestamp;
                }
            }
        }

        return result;
    },

    /** 
    * えんてつポイント 遠鉄顧客データ取得
    * easpro側から顧客データを取得する。
    * @param {String} kaiNo, お客様番号
    **/
    getEntetsuKokyakuInfo: async function(kaiNo){
        const response = await axios.post(UrlConstants.ECSITE + UrlConstants.PG010MAIN + UrlConstants.GET_ENTETSU_KOKYAKU_INFO, kaiNo);

        if (response){
            if (response.data){
                return response.data;
            }
        }
        return null;
    },

    /** 
    * えんてつポイント 遠鉄ポイント付与利用マトリクス表データ取得
    * @param {String} cardType, お客様番号
    **/
    getEntetsuPointMatrixData: async function(cardType){
        const response = await axios.post(UrlConstants.ECSITE + UrlConstants.PG010MAIN + UrlConstants.GET_ENTETSU_POINT_MATRIX_DATA, cardType);

        if (response){
            if (response.data){
                if (response.data.response){
                    return response.data.response;
                }
            }
        }
        return null;
    },

    /** 
    * えんてつポイント 遠鉄顧客データ取得
    * easpro側から顧客データを取得する。
    * @param {String} mail, メール
    * @param {String} password, パスワード
    **/
    doAutoLogin: async function(mail, password){
        var _this = this;
        let pt060Request = {
            mailAddress: mail,
            password: password,
            shahanFlg: ''
        }
        // Call API login
        let response = await axios.post(UrlConstants.ECSITE + UrlConstants.PT060 + UrlConstants.AUTO_LOGIN, pt060Request);

        return response.data;
    },

    showError: function(errorMsg, parents){
        parents.$nextTick(() => {
            parents.showErrorPopup(errorMsg);
        });
    },
    showModalError: function(errorMsg, parents, callback = () => {}) {
        parents.$nextTick(() => {
            parents.showErrorPopup(errorMsg, callback);
        });
    },
    showErrorCallBack: async function(router, entetsuLoginFlg, curPageNo, gotoErrorPageNo){
        await this.clear();
        if (entetsuLoginFlg == 1){
            await this.logout(router, gotoErrorPageNo);
        }else{
            this.gotoTopPage(router, gotoErrorPageNo);
        }
        if (curPageNo == 1 && gotoErrorPageNo == 1){
            router.go(0);
        }
    },

    main: async function(router, parents, entetsuLoginFlg, entetsuCookieUrl){
        let _this = this;
        //セッション状態チェック結果
        let result1 = null;
        //オートログイン状態チェック結果
        let result2 = null;
        //セッション状態更新API結果
        let result3 = null;
        //ネット会員照会結果
        let result4 = null;

        let pageNo = 1;
        let gotoErrorPageNo = 1;
        try{
             _this.cookieUrl = entetsuCookieUrl;

            if (parents.$data.pg010MainRequest.pageNo){
                pageNo = parents.$data.pg010MainRequest.pageNo;
                if (pageNo == 18){
                    gotoErrorPageNo = 18
                }
            }
            
            await _this.getEntetsuCookie();

            if ((!_this.cookieSesStatusCd) && (!_this.cookieAutoLoginStatusCd)){
                console.log('entetsu cookie is missing!');
                sessionStorage.removeItem('kaiin');
                sessionStorage.removeItem('kainInfo');
                sessionStorage.removeItem('entetsu_logout_flg');

                //_this.showError(parents.$t("entetsu.messages.sessionExpired"), parents);

                if (entetsuLoginFlg == 1){
                    await _this.logout(router, 1);
                }
                if (pageNo == 18){
                    //_this.gotoTopPage(router, 18);
                     return false;
                }           

                return false;                
            }

            if (sessionStorage.getItem('entetsu_logout_flg') == '1'){
                await _this.clear();
                if (entetsuLoginFlg == 1){
                    await _this.logout(router, -1);
                }
                return false;
            }

            gotoErrorPageNo = 1;

            //JSESSIONID設定
            if (!_this.cookieSesId){
                //取得
                _this.cookieSesId = await _this.getSessionId();
                //設定
                await _this.setCookie("JSESSIONID", _this.cookieSesId, -1);
            }
    
            //➀セッション状態チェック
            result1 = await _this.sessionStatusCheck();
    
            //セッション情報がない場合または無効の場合は②の処理に、有効の場合は➂の処理に進める。
            if ((result1.sesStatusCd == '') || (result1.kekka == '10' && result1.sesStatus == '2')){
                //Cookieにセッション状態コードがない場合は「オートログイン状態更新」APIを実施する。
                //APIの処理結果が10（正常）かつ、セッション状態結果が2（セッションなし）の場合は「オートログイン状態確認」APIを実施する。
    
                //②オートログイン状態チェック
                result2 = await _this.autoLoginStatusCheck();
    
                //オートログイン情報が有効の場合はAPIにて返された内容で下記Cookieを更新した上、➂の処理に進める。
                if (result2.kekka == '10' && result2.autoLoginStatus == '1'){
                    //➂セッション状態更新API
                    result3 = await _this.sessionUpdCheck(result2.sesStatusCd);
                }else{
                    //②APIの処理結果が10（正常）かつオートログイン状態結果が2（ログイン不可）　または、処理結果が10（正常）以外の場合はセッション切れの状態とし、元画面に戻す。
                    _this.showModalError(parents.$t("entetsu.messages.apiResultErrMsg"), parents, async () => {
                        await _this.showErrorCallBack(router, entetsuLoginFlg, pageNo, gotoErrorPageNo);
                    });
                    return false;
                }
    
            }else if ((result1.sesStatusCd != '') && (result1.kekka == '10' && result1.sesStatus == '1')){
                //➀APIの処理結果が10（正常）かつ、セッション状態結果が1（セッションあり）の場合は「セッション状態更新」APIを実施する。
    
                //➂セッション状態更新API
                result3 = await _this.sessionUpdCheck(result1.sesStatusCd);
            }else{
                //APIの処理結果が10（正常）以外の場合は、E-ASPRO上はセッション切れの状態とし、元画面に戻す。
                _this.showModalError(parents.$t("entetsu.messages.apiResultErrMsg"), parents, async () => {
                    await _this.showErrorCallBack(router, entetsuLoginFlg, pageNo, gotoErrorPageNo);
                });
                
                return false;
            }
    
            //➃ポイント情報取得
            //➂APIの処理結果が10（正常）の場合はAPIにて返された内容で下記Cookieを更新した上、「ネット会員照会」APIを実施する。
            if (result3 != null && result3.kekka == '10' ){
                //「ネット会員照会」APIを実施する
                result4 = await _this.netmemberinfoCheck(result3.kaiNo);
    
                if (result4 != null){
                    if (result4.kekka == '10'){
                        //sessionStorage.setItem('kaiNo', result4.kaiNo);
                        let kanouPoint = 0;
                        if (result4.kanouPoint){
                            if (result4.kanouPointF == '-'){
                                kanouPoint = (-1) * parseInt(result4.kanouPoint);
                            }else{
                                kanouPoint = parseInt(result4.kanouPoint);
                            }
                        }else{
                            kanouPoint = 0;
                        }
    
                        //easpro側から顧客データを取得する
                        let kokyakuResult = await _this.getEntetsuKokyakuInfo(result4.kaiNo);
                        let kokyaku = null;
                        let kokyakuRankKbn = '';
                        if  (kokyakuResult.response){
                            kokyaku = kokyakuResult.response;
                            kokyakuRankKbn = kokyaku.KOKYAKU_RANK_KBN;
                        }

                        //※カードあり会員（お客様番号の先頭が「06」以外）かカードなし会員（お客様番号の先頭が「06」）で切り分ける
                        let cardKaiinFlg = (result4.kaiNo.substring(0,2) == '06') ? 0 : 1;

                        //有効なカード：有効期限内、およびおよびカード状態が0,10,32（※現金カードは有効期限が空白で返ってくる）
                        //カード状態不明：カード状態が空白（時間外）
                        const now = new Date();
                        const year = String(now.getFullYear()).substring(2);
                        const month = String(now.getMonth() + 1).padStart(2, '0');
                        const yymm = year + month;

                        const nowTime = new Date();
                        let strTime = nowTime.getHours().toString().padStart(2, '0') + nowTime.getMinutes().toString().padStart(2, '0');

                        //有効期限フラグ 0:期限内 1:期限切れ
                        let expiredFlg = 0;
                        //退会/停止フラグ 1:退会/停止
                        let stopFlg = 0;
                        //付与ポイント数(1:表示 0:非表示)
                        let pointPlusFlg = 1;
                        //ポイント付与(1:可能 0:不可)
                        let pointGiveFlg = 1;
                        //ポイント利用(1:可能 0:不可)
                        let pointRiyoFlg = 1;
                        //メンテナンス時間帯フラグ(1:メンテナンス時間帯 0:メンテナンス時間帯じゃない)　
                        let maintenanceFlg = 0;
                        let errorMsg = "";
                        let cardType = 1;// 1:有効なカード 2:無効なカード 3:カード状態不明（時間外）
                        let pointMatrix = null;

                        if (result4.cardSyuFlg == '0' || result4.cardSyuFlg == '5' || result4.cardSyuFlg == '7' || result4.cardSyuFlg == '4'){
                            //ポイント専⽤カード/百貨店応援社員ポイント専⽤カード
                            if (result4.cardJyotai == '' || result4.cardJyotai == '00' || result4.cardJyotai == '10' || result4.cardJyotai == '32'){
                                if (result4.yukoDate == '' || yymm <= result4.yukoDate){
                                    cardType = 1;
                                }else{
                                    cardType = 2;
                                    expiredFlg = 1;
                                }
                            }else{
                                cardType = 2;
                                stopFlg = 1;
                            }
                        }else if (result4.cardSyuFlg == '2' || result4.cardSyuFlg == '3'){
                            //ポイント&ﾌﾟﾘﾍﾟｲﾄﾞカード
                            if (result4.cardJyotai == '' || result4.cardJyotai == '00' || result4.cardJyotai == '10'){
                                if (result4.yukoDate == '' || yymm <= result4.yukoDate){
                                    cardType = 1;
                                }else{
                                    cardType = 2;
                                    expiredFlg = 1;
                                }
                            }else{
                                cardType = 2;
                                stopFlg = 1;
                            }
                        }else if (result4.cardSyuFlg == '1' || result4.cardSyuFlg == '6' || result4.cardSyuFlg == '8'){
                            //ポイント&クレジットカード
                            if (result4.cardJyotai == '' || result4.cardJyotai == '10'){
                                if (result4.yukoDate == '' || yymm <= result4.yukoDate){
                                    cardType = 1;
                                }else{
                                    cardType = 2;
                                    expiredFlg = 1;
                                }
                            }else{
                                cardType = 2;
                                stopFlg = 1;
                            }
                        }else{
                            //カード状態が空白（時間外）
                            if (result4.cardSyuFlg == '' && result4.cardJyotai == ''){
                                cardType = 3;
                            }
                        }

                        if (cardType == 1){
                            //付与ポイント数(1:表示 0:非表示)
                            pointPlusFlg = 1;
                            //ポイント付与(1:可能 0:不可)
                            pointGiveFlg = 1;
                            //ポイント利用(1:可能 0:不可)
                            pointRiyoFlg = 1;
                        }else if (cardType == 2){
                            //付与ポイント数(1:表示 0:非表示)
                            pointPlusFlg = 0;
                            //ポイント付与(1:可能 0:不可)
                            pointGiveFlg = 0;
                            //ポイント利用(1:可能 0:不可)
                            pointRiyoFlg = 0;
                        }else if (cardType == 3){
                            //付与ポイント数(1:表示 0:非表示)
                            pointPlusFlg = 1;
                            //ポイント付与(1:可能 0:不可)
                            pointGiveFlg = 1;
                            //ポイント利用(1:可能 0:不可)
                            pointRiyoFlg = 0;
                            //メンテナンス時間帯フラグ(1:メンテナンス時間帯 0:メンテナンス時間帯じゃない)　
                            maintenanceFlg = 1;
                        }

                        //遠鉄ポイント付与利用マトリクス表データ取得
                        pointMatrix =  await _this.getEntetsuPointMatrixData(cardType);
                        //console.log(pointMatrix);
                        if (pointMatrix != null){
                            //付与ポイント数(1:表示 0:非表示)
                            pointPlusFlg = pointMatrix.POINT_PLUS_FLG;
                            //ポイント付与(1:可能 0:不可)
                            pointGiveFlg = pointMatrix.POINT_GIVE_FLG;
                            //ポイント利用(1:可能 0:不可)
                            pointRiyoFlg = pointMatrix.POINT_RIYO_FLG;
                            //メンテナンス時間帯フラグ(1:メンテナンス時間帯 0:メンテナンス時間帯じゃない)　
                            maintenanceFlg = pointMatrix.MAINTENANCE_FLG;
                        }

                        let  kainInfo = {
                            kaiNo: result4.kaiNo,
                            RankKbn:kokyakuRankKbn,
                            cardKaiinFlg: cardKaiinFlg,
                            cardType: cardType,
                            kanouPoint: kanouPoint,
                            pointPlusFlg: pointPlusFlg,
                            pointGiveFlg: pointGiveFlg,
                            pointRiyoFlg: pointRiyoFlg,
                            maintenanceFlg: maintenanceFlg,
                            expiredFlg: expiredFlg,
                            stopFlg: stopFlg,
                            sesId:_this.cookieSesId
                        }
                        sessionStorage.setItem('kainInfo', JSON.stringify(kainInfo));

                        let kaiin = {
                            cardKaiinFlg: cardKaiinFlg,
                            kaiNo: result4.kaiNo,
                            firstLoginFlg: 0,
                            existsFlg: 0
                        };
                        if (cardKaiinFlg == 1){
                            //カードあり会員
                            //姓
                            kaiin.nm1 = result4.nname1;
                            //名
                            kaiin.nm2 = result4.nname2;
                            //姓カナ
                            kaiin.kana1 = result4.kname1;
                            //名カナ
                            kaiin.kana2 = result4.kname2;
                            //生年月日
                            if (result4.birth){
                                kaiin.birthDayYYYY = result4.birth.substring(0, 4);
                                kaiin.birthDayMM = result4.birth.substring(4, 6);
                                kaiin.birthDayDD = result4.birth.substring(6);
                            }

                        }else{
                            //カードなし会員
                            //姓
                            kaiin.nm1 = result4.nname1;
                            //名
                            kaiin.nm2 = result4.nname2;
                            //姓カナ
                            kaiin.kana1 = result4.kname1;
                            //名カナ
                            kaiin.kana2 = result4.kname2;
                            //性別
                            kaiin.sexKbn = result4.sex;
                            //郵便番号1･2
                            kaiin.zip = result4.zip1 + result4.zip2;
                            //都道府県
                            kaiin.kenCd = result4.ken;
                            //住所1～3
                            kaiin.addr1 = result4.adr1;
                            kaiin.addr2 = result4.adr2;
                            kaiin.addr3 = result4.adr3;
                            //電話番号:電話番号（自宅）1がある場合は自宅を利用電話番号（自宅）1がない場合は携帯を利用
                            if (result4.jtel1 !=''){
                                kaiin.tel1 = result4.jtel1  + result4.jtel2 + result4.jtel3;
                            }
                            if (kaiin.tel1 ==''){
                                kaiin.tel1 = result4.ktel1  + result4.ktel3 + result4.ktel3;
                            }
                            //生年月日
                            if (result4.birth){
                                kaiin.birthDayYYYY = result4.birth.substring(0, 4);
                                kaiin.birthDayMM = result4.birth.substring(4, 6);
                                kaiin.birthDayDD = result4.birth.substring(6);
                            }
                        }

                        if (kokyaku){
                            kaiin.firstLoginFlg = kokyaku.FIRST_LOGIN_FLG;
                            kaiin.existsFlg = 1;
                            if (kokyaku.FIRST_LOGIN_FLG == 0){
                                //初回ログイン用注文者登録画面（個人）
                                if (pageNo == 8){
                                    sessionStorage.setItem('kaiin', JSON.stringify(kaiin));
                                }
                                router.push({ name: SiteConstants.PG010MAIN, query: {pageNo: 8}, params: kaiin});
                                return true;
                            }

                            //退会顧客　登録ができません
                            if (kokyaku.TAIKAI_FLG == 1){
                                _this.showError(parents.$t("entetsu.messages.apiResultErrMsg"), parents);
                                /*_this.showModalError(parents.$t("entetsu.messages.apiResultErrMsg"), parents, async () => {
                                    await _this.showErrorCallBack(router, entetsuLoginFlg, pageNo, gotoErrorPageNo);
                                });*/
                                return false;
                            }

                            //内部ログイン処理
                            let loginResult = await _this.doAutoLogin(kokyaku.KOKYAKU_CD, kokyaku.KOKYAKU_CD);
                            if (loginResult.status == 'OK'){
                                if (loginResult.response.loginProblem == 'LOGIN_OK'){
                                    if (entetsuLoginFlg == 0){
                                        if (pageNo){
                                            if (pageNo == 1 || pageNo == 18){
                                                router.push({ name: SiteConstants.PG010MAIN, query: {pageNo: 1}});
                                            }
                                        }
                                    }else{
                                        if (pageNo){
                                            if (pageNo == 18){
                                                router.push({ name: SiteConstants.PG010MAIN, query: {pageNo: 1}});
                                            }
                                        }
                                    }
                                    console.log('遠鉄個人会員 Auto Logined');
                                }else{
                                    console.log(loginResult.response.loginMsg);
                                    _this.showError(parents.$t("entetsu.messages.apiResultErrMsg"), parents);
                                    /*_this.showModalError(parents.$t("entetsu.messages.apiResultErrMsg"), parents, async () => {
                                        await _this.showErrorCallBack(router, entetsuLoginFlg, pageNo, gotoErrorPageNo);
                                    });*/
                                }
                            }else{
                                router.push({ name: SiteConstants.PG010MAIN, query: {pageNo: 1}});
                            }
                        }else{   
                            //初回ログイン用注文者登録画面（個人）
                            if (pageNo == 8){
                                sessionStorage.setItem('kaiin', JSON.stringify(kaiin));
                            }
                            router.push({ name: SiteConstants.PG010MAIN, query: {pageNo: 8}, params: kaiin});
                        }
                    }else{
                        _this.showModalError(parents.$t("entetsu.messages.apiResultErrMsg"), parents, async () => {
                            await _this.showErrorCallBack(router, entetsuLoginFlg, pageNo, gotoErrorPageNo);
                        });
                        return false;
                    }
                }else{
                    _this.showModalError(parents.$t("entetsu.messages.apiResultErrMsg"), parents, async () => {
                        await _this.showErrorCallBack(router, entetsuLoginFlg, pageNo, gotoErrorPageNo);
                    });
                    return false;
                }
            }else{
                //➂APIの処理結果が10（正常）以外の場合はセッション切れの状態とし、元画面に戻す。
                _this.showModalError(parents.$t("entetsu.messages.apiResultErrMsg"), parents, async () => {
                    await _this.showErrorCallBack(router, entetsuLoginFlg, pageNo, gotoErrorPageNo);
                });
                return false;
            }

            return true;
        }catch(ex){
            _this.showError(parents.$t("entetsu.messages.apiErrMsg"), parents);
            console.log('えんてつAPIエラー:');
            console.log(ex);
            return false;
        }       
    }
}
window.entetsu = entetsu;
export default entetsu